<template>
  <div v-if="covidNotice" class="alert" role="alert">
    <div>
      <button
        type="button"
        class="alert-guidance-btn"
        @click="showModal = true"
      >
        <i class="info_caution"></i>
        <h5 class="mgr40 fs14">Covid-19安全対策について</h5>
        <p class="alert-guidance-details fwB">
          <i class="fa fa-chevron-circle-right fs16"></i>&nbsp;詳細はこちら
        </p>
      </button>
    </div>
    <tk-modal
      v-if="showModal"
      modal-size="lg"
      no-show-header
      :no-sp-fullscreen="true"
      style="padding-right: 0px;"
    >
      <div class="modal-content">
        <h3 class="text-center pdt30"><strong>清掃と安全性確保</strong></h3>
        <br />
        <br />
        <div class="row pdl80 pdr40 pdb30">
          <span style="font-size: 14px;">
            <!-- eslint-disable vue/no-v-html -->
            <strong v-html="covidNotice"></strong>
            <!--eslint-enable-->
          </span>
        </div>
        <div class="Price_back2 pd10 width100Rest sp_dpb" style="clear: both;">
          <div class="row">
            <div class="w50p mglrauto">
              <p>
                <a class="btn btn-block btn-Green" @click="showModal = false">
                  閉じる
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </tk-modal>
  </div>
</template>

<script>
import TkModal from '../../atoms/TkGlobalModal/TkGlobalModal'

const COVID_ATTRIBUTE_GENERAL = [
  1073744990,
  1073744991,
  1073744992,
  1073744993,
  1073744994,
  1073744995,
  1073744996,
  1073744997,
  1073744998,
  1073744999,
  1073745000,
  1073745001,
  1073745002,
  1073745003,
  1073745004,
  1073745005,
  1073745006,
  1073745007,
  1073745008,
  1073745009,
  1073745010,
  1073745011,
  1073745012,
  1073745013,
  1073745014,
  1073745015,
  1073745016,
  1073745017,
  1073745018,
  1073745019,
  1073745020,
  1073745021,
  1073745022,
  1073745045,
  1073745046,
  1073745047,
  1073745048,
  1073745049,
  1073745050,
  1073745051,
  1073745052,
  1073745053,
  1073745054,
  1073745055,
  1073745056,
  1073745057,
  1073745058,
  1073745059,
  1073745060,
  1073745061,
  1073745062,
  1073745063,
  1073745064,
  1073745065,
  1073745066,
]

export default {
  name: 'TkHotelNCovidInformation',
  components: { TkModal },
  props: {
    attributes: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data: function () {
    return { showModal: false }
  },
  computed: {
    covidNotice() {
      const notice = Object.entries(this.attributes)
        .filter(([key, value]) => COVID_ATTRIBUTE_GENERAL.includes(value.id))
        .map((item) => item[1].name)
      return notice.join('<br />')
    },
  },
}
</script>
